import React from "react";
import { FormGroup, Label, Input, FormText } from "reactstrap";
import ElementSpacer from "../../../Layout/Components/ElementSpacer";

type Props = {
  label?: string | undefined;
  description?: string | undefined;
  type?:
    | "text"
    | "email"
    | "select"
    | "file"
    | "radio"
    | "checkbox"
    | "textarea"
    | "button"
    | "reset"
    | "submit"
    | "date"
    | "datetime-local"
    | "hidden"
    | "image"
    | "month"
    | "number"
    | "range"
    | "search"
    | "tel"
    | "url"
    | "week"
    | "password"
    | "datetime"
    | "time"
    | "color";
  name?: string | undefined;
  autoComplete?: string | undefined;
  required?: false | true | undefined;
  value?: string | number | Array<string> | undefined;
  rows?: number | undefined;
  disabled?: boolean;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  min?: number;
};

export const FeedbackFormInput: React.FC<Props> = props => {
  return (
    <FormGroup>
      <Label for={props.name}>
        <ElementSpacer spacing=".25rem">
          {props.label}
          {!!props.required && props.required ? <span className="text-danger">*</span> : ""}
        </ElementSpacer>
      </Label>
      <Input
        type={props.type}
        name={props.name}
        autoComplete={props.autoComplete}
        required={props.required}
        value={props.value ?? ""}
        onChange={props.onChange}
        rows={props.rows}
        readOnly={props.disabled}
        min={props.min}
      />
      <FormText>{props.description}</FormText>
    </FormGroup>
  );
};
